import cx from 'classnames';
import { useFormikContext } from 'formik';
import React, { useCallback, useState } from 'react';
import bt from '../bootstrap.module.css';
import FormElementWrapper from '../components/FormElementWrapper';
import InlineEdit from '../components/InlineEdit';
import ObligationSource from '../components/ObligationSource';
import useGetFormGeneratorItemError from '../hooks/useGetFormGeneratorItemError';

const MultipleChoice = props => {
  const { isBuilder, onChange, data, disabled, value = [], readOnly } = props;
  const { requiredError } = useGetFormGeneratorItemError(data.id);
  const [isEditing, setIsEditing] = useState(false);
  const { setFieldValue, values } = useFormikContext();
  const index = values?.data?.findIndex(({ id }) => id === props.data.id);

  const handleChange = useCallback(
    e => {
      const { value: id, checked } = e.target;
      onChange(data.type, data.id, checked ? [...value, id] : value.filter(xId => xId !== id));
    },
    [onChange, value, data.type, data.id],
  );

  const handleLabelChange = e => {
    const { name, value } = e.target;
    setFieldValue(`data[${index}].${name}`, value);
  };

  return (
    <FormElementWrapper {...props} onClick={!readOnly ? () => setIsEditing(true) : undefined}>
      <div className={bt['form-group']}>
        <div className="font-semibold">
          <InlineEdit
            value={data.label}
            onChange={handleLabelChange}
            fieldName="label"
            isEditing={isEditing}
            onSetIsEditing={setIsEditing}
            readOnly={readOnly}
          />
        </div>
        {data.compliance && <ObligationSource source={data.obligationSource} />}

        {(props.data?.options || []).map(option => {
          const this_key = option.id;

          return (
            <div className={cx(bt['custom-control'], bt['custom-checkbox'])} key={this_key}>
              <input
                id={`${isBuilder ? 'builder_' : ''}fid_${this_key}`}
                className={bt['custom-control-input']}
                onChange={handleChange}
                checked={value.includes(option.id)}
                disabled={isBuilder || disabled}
                name={`option_${option.id}`}
                type="checkbox"
                value={option.id}
              />
              <label
                className={cx(bt['custom-control-label'], 'cursor-pointer')}
                htmlFor={`${props.isBuilder ? 'builder_' : ''}fid_${this_key}`}
                style={{
                  marginBottom: 8,
                }}
              >
                {option.label}
              </label>
            </div>
          );
        })}
        {requiredError && <div style={{ color: 'red', marginTop: 4 }}>This field is required</div>}
      </div>
    </FormElementWrapper>
  );
};

export default MultipleChoice;
